import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import { useRouteMatch } from "../../../utils/router";
import PageHeader from "../../general/PageHeader";
import { getLink, permisions, toast } from "../../../utils/helpers";
import FiltersContainer from "../../general/FiltersContainer";
import dayjs from "dayjs";
import useFilters from "../../../hooks/useFilters";
import { downloadFile, request } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import Loader from "../../general/Loader";
import { apiRequest } from "../../../hooks/apiRequest";
import Dropdown from "../../general/Dropdown";
import Modal from "../../general/Modal";
import Pagination from "../../general/Pagination";

const Visitas = ({paciente_id}) => {
    const match = useRouteMatch();

    const [loading, setLoading] = useState(false);
    const [visitas, setVisitas] = useState({});
    const [selectedVisita, setSelectedVisita] = useState();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const defaultDesde = dayjs(new Date(new Date().setDate(1))).format("YYYY-MM-DD");
    const defaultHasta = dayjs(new Date()).format("YYYY-MM-DD");

    const { handleFilterChange, filtersQuery } = useFilters({
        buscar: null, desde: defaultDesde, hasta: defaultHasta, tipo: null,
    });

    const getVisitas = async (url) => {
        url = url ? url + "&limit=15" : `salud/visitas?limit=15`;

        if (paciente_id) {
            url += `&paciente=${paciente_id}`;
        }

        setLoading(true);

        const response = await request(url);

        setVisitas(response);

        setLoading(false);
    };

    const openDeleteModal = (visita) => {
        setSelectedVisita(visita);

        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setSelectedVisita();

        setShowDeleteModal(false);
    };

    const eliminarVisita = async () => {
        setDeleting(true);

        const response = await apiRequest({}, `salud/visitas/${selectedVisita.id}`, 'delete');

        if (response.success) {
            toast("Visita Eliminada", "success");
            
            closeDeleteModal();

            getVisitas(`salud/visitas${filtersQuery}`);
        } else {
            toast(response.data.message, "error");
        }

        setDeleting(false);
    };

    useEffect(() => {
        getVisitas(`salud/visitas${filtersQuery}`);
    }, [filtersQuery]);


    return <>
        <PageHeader title="Visitas">
            {auth.can(permisions.reporteSaludVisitas) && <Link
                className='au-btn au-btn-icon au-btn-filter au-btn--small mr-2'
                to={getLink(
                    `/imprimir/salud/visitas${filtersQuery}${paciente_id ? `&paciente=${paciente_id}` : ''}`
                    )}
                target='_blank'>
                <i className='zmdi zmdi-print' />
                Imprimir
            </Link>}
            {auth.canEdit(permisions.visitaSalud) && !paciente_id && <Link
                className="au-btn au-btn-icon au-btn--green au-btn--small m-r-15 ml-auto mt-2 mt-lg-0"
                to={`${match.url}/crear`}
            >
                <i className="zmdi zmdi-plus" />
                Nueva Visita
            </Link>}
        </PageHeader>

        <FiltersContainer>
            <div className='col'>
                <label htmlFor='search'>Buscar</label>
                <input
                    name='buscar'
                    onChange={(e) => handleFilterChange("buscar", e?.target.value)}
                    type='search'
                    placeholder='Buscar...'
                    className='form-control'
                />
            </div>

            <div className='col'>
                <label htmlFor='estado'>Tipo de Visita</label>
                <select
                    name="tipo"
                    className="form-control"
                    placeholder="Seleccionar..."
                    onChange={e => handleFilterChange('tipo', e.target.value)}
                >
                    <option value="">Todas</option>
                    <option value="Médica">Médica</option>
                    <option value="Psicología">Psicología</option>
                </select>
            </div>

            <div className='col'>
                <label htmlFor='desde'>Desde</label>
                <input onChange={(e) => handleFilterChange("desde", e.target.value)}
                    type="date"
                    className='form-control'
                    name='desde'
                    id="desde"
                    defaultValue={defaultDesde}
                />
            </div>

            <div className='col'>
                <label htmlFor='hasta'>Hasta</label>
                <input onChange={(e) => handleFilterChange("hasta", e.target.value)}
                    type="date"
                    className='form-control'
                    name='hasta'
                    id="hasta"
                    defaultValue={defaultHasta}
                />
            </div>
        </FiltersContainer>

        <div className='row'>
            <div className='col-md-12'>
                <div>
                    <div className='table-data'>
                        <table className='table table-data2'>
                            <thead>
                                <tr>
                                    <th colSpan={2}>Paciente</th>
                                    <th>Tipo Contacto</th>
                                    <th>Fecha</th>
                                    <th>Motivo</th>
                                    <th>Tipo de Visita</th>
                                    <th>Observaciones</th>
                                    <th>Signos</th>
                                    <th>Diagnóstico</th>
                                    <th>Derivación EXterna</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody>
                                {loading
                                    ? (<tr className="tr-shadow"><td colSpan={11}><Loader /></td></tr>)
                                    : (visitas?.data?.length
                                        ? visitas.data.map((visita) => (<tr className="tr-shadow" key={visita.id}>
                                            <td style={{padding: '5px', overflow: 'hidden'}}>
                                                <span className="page-title-foto m-0">
                                                    <img src={visita.paciente.foto ?? '/images/icon/avatar.png'} alt={visita.paciente.codigo} />
                                                </span>
                                            </td>
                                            <td>{visita.paciente.nombre_completo}</td>
                                            <td>{visita.paciente.tipo}</td>
                                            <td>{dayjs(visita.fecha).format('DD/MM/YYYY hh:mm a')}</td>
                                            <td>{visita.motivo.descripcion}</td>
                                            <td>{visita.tipo}</td>
                                            <td style={{
                                                maxWidth: '120px',
                                                padding: '5px',
                                                overflowWrap: 'break-word',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                maxHeight: 'calc(1.5em * 3.2)',
                                                display: 'flex',
                                            }}>{visita.observaciones}</td>
                                            <td style={{width: '160px', padding: '5px'}}>
                                                {Object.entries(visita.signos).map(([key, value]) => (
                                                    <div className="row" key={key}>
                                                        <div className="capitalize" style={{width: '100px'}}><strong>{key}</strong></div>
                                                        <div className="col text-right">{value}</div>
                                                    </div>
                                                ))}
                                            </td>
                                            <td style={{
                                                maxWidth: '120px',
                                                padding: '5px',
                                                overflowWrap: 'break-word',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                maxHeight: 'calc(1.5em * 3.2)',
                                                display: 'flex',
                                            }}>{visita.diagnostico}</td>
                                            <td>{visita.derivacion ? 'Sí' : 'No'}</td>
                                            <td>{auth.canEdit(permisions.visitaSalud) && (
                                                <div className='table-data-feature'>
                                                    <Link
                                                        to={getLink(`/salud/visitas/${visita.id}`)}
                                                        className="item"
                                                        style={{ background: 'transparent' }}
                                                    >
                                                        <i className='zmdi zmdi-edit text-warning' />
                                                    </Link>

                                                    <button
                                                        className='item'
                                                        data-toggle='tooltip'
                                                        data-placement='top'
                                                        title=''
                                                        data-original-title='Eliminar'
                                                        onClick={() => openDeleteModal(visita) }
                                                        style={{ background: 'transparent' }}>
                                                        <i className='zmdi zmdi-delete text-danger' />
                                                    </button>
                                                </div>
                                            )}
                                                
                                                
                                            {/* {auth.canEdit(permisions.visitaSalud) && visita.documentos?.length >= 1 && <Dropdown
                                                classes={{ button: "w-100", dropdownMenu: "align-right" }}
                                                styles={{button: {height: "38px", lineHeight: "0px"}, dropdownMenu: {zIndex: "99"}}}
                                            >
                                                {visita.documentos?.map(documento => (
                                                    <button onClick={() => {downloadFile(documento.url, documento.nombre ?? `documento_${documento.id}`)}} className="dropdown-item" rel="noreferrer">
                                                        {documento.nombre ?? `documento_${documento.id}`}
                                                    </button>
                                                ))}
                                            </Dropdown>} */}
                                            </td>
                                        </tr>))
                                        : <tr className="tr-shadow"><td colSpan={11}>No hay ninguna Visita creada.</td></tr>
                                    )
                                }
                            </tbody>
                        </table>

                        {visitas?.links && (<Pagination links={visitas.links} meta={visitas.meta} getData={getVisitas} />)}
                    </div>
                </div>
            </div>
        </div>

        <Modal
            title={`Eliminar Visita de ${selectedVisita?.paciente.nombre_completo}`}
            show={showDeleteModal}
            blank={false}
            callback={eliminarVisita}
            toggle={closeDeleteModal}>
                {
                    deleting 
                    ? <><Loader /></> 
                    : <p className="px-3 pb-3">¿Estás seguro que desea eliminar esta visita? (Esta acción no se puede deshacer).</p>
                }
        </Modal>
    </>;
};

export default Visitas;